import { Modal } from '@bp/ui-components';
import { Dayjs } from 'dayjs';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SubstitutionDataEntry } from '../../../pages/Substitutions/Plan/PlanSubstitutions/utils';
import { WorkOrderForm } from '../forms/WorkOrderForm';

type WorkOrderModalProps = {
  isOpen: boolean;
  originTeachers: SubstitutionDataEntry[];
  originRooms: SubstitutionDataEntry[];
  eventStart: Dayjs;
  eventEnd: Dayjs;
  eventUuid: string;
  onClose: () => void;
  comment: string;
};

export const WorkOrderModal = ({
  isOpen,
  originTeachers,
  originRooms,
  eventStart,
  eventEnd,
  onClose,
  eventUuid,
  comment,
}: WorkOrderModalProps) => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState<boolean>(false);

  return (
    <Modal width='s' loading={loading} title={t('substitutions.workOrder')} isOpen={isOpen} onRequestClose={onClose}>
      <WorkOrderForm
        originTeachers={originTeachers}
        originRooms={originRooms}
        eventStart={eventStart}
        eventEnd={eventEnd}
        eventUuid={eventUuid}
        comment={comment}
        onLoad={setLoading}
        onClose={onClose}
      />
    </Modal>
  );
};
